<!--
 Open MCT, Copyright (c) 2014-2024, United States Government
 as represented by the Administrator of the National Aeronautics and Space
 Administration. All rights reserved.

 Open MCT is licensed under the Apache License, Version 2.0 (the
 "License"); you may not use this file except in compliance with the License.
 You may obtain a copy of the License at
 http://www.apache.org/licenses/LICENSE-2.0.

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 License for the specific language governing permissions and limitations
 under the License.

 Open MCT includes source code licensed under additional open source
 licenses. See the Open Source Licenses file (LICENSES.md) included with
 this source code distribution or the Licensing information page available
 at runtime from the About dialog for additional information.
-->
<template>
  <div ref="clockMenuButton" class="c-ctrl-wrapper c-ctrl-wrapper--menus-up">
    <div class="c-menu-button c-ctrl-wrapper c-ctrl-wrapper--menus-left">
      <button
        v-if="selectedClock"
        class="c-icon-button c-button--menu js-clock-button"
        :class="selectedClock.cssClass"
        aria-label="Independent Time Conductor Clock Menu"
        @click.prevent.stop="showClocksMenu"
      >
        <span class="c-button__label">{{ selectedClock.name }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['openmct', 'clock', 'getAllClockMetadata', 'getClockMetadata'],
  props: {
    enabled: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  computed: {
    selectedClock() {
      return this.getClockMetadata(this.clock);
    }
  },
  watch: {
    enabled(newValue, oldValue) {
      if (newValue !== undefined && newValue !== oldValue && newValue === true) {
        this.setViewFromClock(this.clock);
      }
    }
  },
  mounted() {
    this.clocks = this.getAllClockMetadata();
  },
  methods: {
    showClocksMenu() {
      const elementBoundingClientRect = this.$refs.clockMenuButton.getBoundingClientRect();
      const x = elementBoundingClientRect.x;
      const y = elementBoundingClientRect.y + elementBoundingClientRect.height;

      const menuOptions = {
        menuClass: 'c-conductor__clock-menu c-super-menu--sm',
        placement: this.openmct.menus.menuPlacement.BOTTOM_RIGHT
      };

      this.openmct.menus.showSuperMenu(x, y, this.clocks, menuOptions);
    },
    setClock(clockKey) {
      this.setViewFromClock(clockKey);
    },
    setViewFromClock(clockOrKey) {
      let clock = clockOrKey;

      if (!clock.key) {
        clock = this.getClock(clockOrKey);
      }

      // if global clock changes, reload and pull it
      this.selectedClock = this.getClockMetadata(clock);
    }
  }
};
</script>
